/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */
import { IAny } from '../../components/DashboardKPIWidgets/IEnergyManagementProps';
class FilterScope1Actions {
  static SHOW_MODAL = 'SHOW_MODAL';
  static SAVE_FILTER_MODAL = 'SAVE_FILTER_MODAL';
  static SAVE_ERROR_MODAL = 'SAVE_ERROR_MODAL';
  static SUBSCRIPTIONDETAILS = 'SUBSCRIPTIONDETAILS';

  static showFilterModal = () => {
    return {
      type: FilterScope1Actions.SHOW_MODAL,
      payload: true
    };
  };

  static hideFilterModal = () => {
    return {
      type: FilterScope1Actions.SHOW_MODAL,
      payload: false
    };
  };
  static saveFilterModal = (getVal: IAny) => {
    return {
      type: FilterScope1Actions.SAVE_FILTER_MODAL,
      payload: getVal
    };
  };
  static saveErrorModal = (getVal: IAny) => {
    return {
      type: FilterScope1Actions.SAVE_ERROR_MODAL,
      payload: getVal
    };
  };
  static subscriptionValue = (getVal: IAny) => {
    return {
      type: FilterScope1Actions.SUBSCRIPTIONDETAILS,
      payload: getVal
    };
  };
}

export default FilterScope1Actions;
